import { render, staticRenderFns } from "./AssetTypeSetup.vue?vue&type=template&id=9968f75e&scoped=true"
import script from "./AssetTypeSetup.vue?vue&type=script&lang=ts"
export * from "./AssetTypeSetup.vue?vue&type=script&lang=ts"
import style0 from "./AssetTypeSetup.vue?vue&type=style&index=0&id=9968f75e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9968f75e",
  null
  
)

export default component.exports